module.exports = __webpack_public_path__ + "static/media/points.d1717bf5.svg";